import addDiscussionsFilter from "./actions/addDiscussionsFilter";

app.initializers.add('netcompany-discussions-filter', () => {
  addDiscussionsFilter();
}, -100); // sets the priority of the initializer
